import { clear, Store } from 'idb-keyval';

const CACHE_NAME = 'GraphQL-Cache';

const STORE_NAME = 'PostResponses';

const idbKeyvalStore = new Store(CACHE_NAME, STORE_NAME);

/**
 * Czyści bazę z cachem
 *
 * @export
 * @returns {Promise<void>}
 */
export function clearIdbStore(): Promise<void> {
  return clear(idbKeyvalStore);
}
